import React from "react";
import AnimatedSection from "./AnimatedSection";

export default function Contact() {
  return (
    <section className="px-4 py-24 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl rounded-[2rem] border border-white/10 bg-white/5 p-8 shadow-[0_30px_80px_rgba(0,0,0,0.25)] backdrop-blur-xl lg:p-12">
        <AnimatedSection className="mb-10 text-center" delay={0.08}>
          <p className="text-sm font-semibold uppercase tracking-[0.3em] text-orange-300">Contact</p>
          <h2 className="mt-3 text-3xl font-semibold text-white sm:text-4xl">Let’s shape something extraordinary together.</h2>
        </AnimatedSection>

        <div className="grid gap-8 lg:grid-cols-[0.9fr_1.1fr]">
          <AnimatedSection className="rounded-[1.5rem] border border-white/10 bg-slate-950/60 p-8" delay={0.12}>
            <h3 className="text-2xl font-semibold text-white">Get in touch</h3>
            <p className="mt-4 text-base leading-8 text-slate-400">We deliver next-level live streaming experiences that feel polished, social, and deeply interactive for creators and communities.</p>
            <div className="mt-8 space-y-4 text-sm text-slate-300">
              <p>📞 +63 965 748 4803</p>
              <p>📧 info@huntsharelive.com</p>
            </div>
            <a href="/downloads/livehunt.apk" className="mt-8 inline-flex rounded-full bg-gradient-to-r from-orange-500 to-fuchsia-600 px-5 py-3 font-semibold text-white shadow-[0_16px_40px_rgba(255,122,61,0.25)]">
              Download Android App
            </a>
          </AnimatedSection>

          <AnimatedSection className="rounded-[1.5rem] border border-white/10 bg-slate-900/60 p-8" delay={0.16}>
            <form className="space-y-5">
              <div>
                <label className="mb-2 block text-sm font-medium text-slate-300">Full Name</label>
                <input type="text" placeholder="Enter your full name" className="w-full rounded-2xl border border-white/10 bg-slate-950/70 px-4 py-3 text-white outline-none transition focus:border-orange-400/60" />
              </div>
              <div>
                <label className="mb-2 block text-sm font-medium text-slate-300">Email</label>
                <input type="email" placeholder="Enter your email" className="w-full rounded-2xl border border-white/10 bg-slate-950/70 px-4 py-3 text-white outline-none transition focus:border-orange-400/60" />
              </div>
              <div>
                <label className="mb-2 block text-sm font-medium text-slate-300">Contact Number</label>
                <input type="tel" placeholder="Enter your contact number" className="w-full rounded-2xl border border-white/10 bg-slate-950/70 px-4 py-3 text-white outline-none transition focus:border-orange-400/60" />
              </div>
              <div>
                <label className="mb-2 block text-sm font-medium text-slate-300">Message</label>
                <textarea rows="4" placeholder="Type your message..." className="w-full rounded-2xl border border-white/10 bg-slate-950/70 px-4 py-3 text-white outline-none transition focus:border-orange-400/60" />
              </div>
              <button type="submit" className="rounded-full bg-gradient-to-r from-orange-500 to-fuchsia-600 px-6 py-3 font-semibold text-white shadow-[0_16px_40px_rgba(255,122,61,0.25)] transition hover:scale-[1.02]">
                Send Message
              </button>
            </form>
          </AnimatedSection>
        </div>
      </div>
    </section>
  );
}
